<div class="settings-tab">
  <div class="links-section">
    @if (userLinksStore.isLoading()) {
    <div class="links-loading">
      <mat-spinner diameter="50"></mat-spinner>
    </div>
    }

    @if (userLinksStore.hasError()) {
    <div class="links-error">
      <p>{{ userLinksStore.error() }}</p>
    </div>
    }

    @if (!userLinksStore.isLoading() && !userLinksStore.hasError()) {
    @if (userLinksStore.records().length > 0) {
    <div class="links-list">
      @for (link of userLinksStore.records(); track link.id) {
      <div class="link-item">
        <div class="link-row">
          <a
            class="link-label-link"
            [href]="link.url"
            target="_blank"
            rel="noopener noreferrer"
          >
            {{ link.label }}
          </a>
          <div class="link-actions">
            <button
              type="button"
              mat-icon-button
              class="link-action-button"
              (click)="copyLinkUrl(link.url, $event)"
              matTooltip="Copy link"
              aria-label="Copy link to clipboard"
            >
              <mat-icon>content_copy</mat-icon>
            </button>
            <button
              type="button"
              mat-icon-button
              class="link-action-button"
              [class.is-active]="expandedLinkId === link.id"
              (click)="toggleUrlVisibility(link.id, $event)"
              [matTooltip]="expandedLinkId === link.id ? 'Hide link URL' : 'Show link URL'"
              [attr.aria-expanded]="expandedLinkId === link.id"
              aria-label="Show or hide full link URL"
            >
              <mat-icon>{{ expandedLinkId === link.id ? 'expand_less' : 'visibility' }}</mat-icon>
            </button>
          </div>
        </div>
        @if (expandedLinkId === link.id) {
        <div class="link-url-expanded" aria-live="polite">{{ link.url }}</div>
        }
      </div>
      }
    </div>
    } @else {
    <div class="no-links">
      <p>No links available at this time.</p>
    </div>
    }
    }
  </div>
</div>